import React, { useEffect, useState } from 'react';

import { useNewThemeActive } from '@repo/ui/theming';
import { addSeconds, differenceInSeconds } from 'date-fns';

import { HintText, ResendButton, ResendWrapper } from './styles';
import { OTPResendProps } from './types';

const OtpResend: React.FC<OTPResendProps> = ({ onResend, timeToResend }) => {
  const isNewThemeActive = useNewThemeActive();
  const [timeLeft, setTimeLeft] = useState(0);

  useEffect(() => {
    setTimeLeft(timeToResend);
    const resendDateTime = addSeconds(new Date(), timeToResend);
    const interval = setInterval(() => {
      const timeLeft = differenceInSeconds(resendDateTime, new Date(), {
        roundingMethod: 'round',
      });
      if (timeLeft >= 0) {
        setTimeLeft(timeLeft);
      } else {
        clearInterval(interval);
      }
    }, 1000);

    return (): void => clearInterval(interval);
  }, [timeToResend]);

  return (
    <ResendWrapper>
      <HintText>Didn't get the code?</HintText>
      {timeLeft ? (
        <HintText>Resend in {timeLeft} seconds</HintText>
      ) : (
        <ResendButton isNewThemeActive={isNewThemeActive} onClick={onResend}>
          Resend
        </ResendButton>
      )}
    </ResendWrapper>
  );
};

export default OtpResend;
